export default __webpack_public_path__ + "static/media/activeMic.0d522c27.png";